import Skeleton from "components/BaseWidgets/skeleton";
import ProfileCard from "components/Cards/profileCard";
import JourneysCarousel from "components/CustomWidgets/journeysCarousel";
import { ExploreContext } from "context/ExploreContext";
import { useBlogList, useSuccessStories } from "hooks/api/useHome";
import { useContext } from "react";
import EmptyState from "components/BaseWidgets/emptyState";
import SubscriptionCard from "components/Cards/subscriptionCard";
import { usePremium } from "context/PremiumContext";
import PremiumCard from "components/Engage/components/PremiumModal";
import OverViewCarousal from "components/CustomWidgets/overViewCarousal";
import useMediaQuery from "hooks/useMediaQuery";
import BlogCard from "components/Cards/blogCard";

function ListCards({
  firstHalf,
  secondHalf,
  isListing,
  tabActive,
  cardClassName,
  ActionChange,
  isCardShow,
  selectedList,
  activeTab,
  secondaryTabActive,
}) {
  const { isPremium } = usePremium();
  const { isLoading, isNotInterested } = useContext(ExploreContext);
  const isMobile = useMediaQuery("(max-width: 820px)");
  const { data: stories = [], isLoading: isStoriesLoading } = useSuccessStories(
    {
      page: 1,
      limit: 6,
      see_all: false,
    },
  );
  const { data: blogData, isLoading: isBlogLoading } = useBlogList({
    see_all: true,
    request_type: 0,
  });

  const shouldShowCarousel = ["1", "3", "5"].includes(tabActive);
  const shouldRenderStories =
    !isNotInterested && !isStoriesLoading && !isListing && !isLoading;

  return (
    <>
      {isLoading ? (
        <div className="explore-card-list">
          {Array.from({ length: 8 }).map((_, index) => (
            <Skeleton label={false} height={250} key={index} />
          ))}
        </div>
      ) : firstHalf?.length ? (
        <div className="explore-card-list relative">
          {firstHalf.map((item) => (
            <ProfileCard
              profile={item}
              ActionChange={ActionChange}
              snippetProfileId={item.id}
              key={item.id}
              profileImage={item?.profileImage}
              verificationType={item?.verificationType}
              imageCount={item?.imageCount}
              userName={item?.profileName}
              lastSeen={item?.lastSeen}
              userAge={item?.profileAge}
              profileId={item?.profileId}
              userHeight={item?.profileHeight}
              religion={item?.religion}
              profession={item?.profileOcc}
              maritalStatus={item?.maritalStatus}
              livesIn={item?.livesIn}
              primaryLanguage={item?.primaryLanguage}
              createdBy={item?.createdBy}
              menuDrop={false}
              isPremium={item?.isPremium}
              isInterested={item?.isLike}
              isNotInterested={isNotInterested}
              isFavorite={item.isFav}
              isImageRequested={item.image_request}
              isPrivate={item.isShow && item.isPrivate}
              contactReqByMe={item?.contactReqByMe}
              contactReqByOthers={item?.contactReqByOthers}
              photoReqByMe={item?.photoReqByMe}
              photoReqByOthers={item?.photoReqByOthers}
              aec_id={item?.aec_id}
              InterestReqByOthers={item?.interestReqByOthers}
              cardClassName={!isPremium ? cardClassName : ""}
              shareUrl={item?.shareUrl}
              tabActive={tabActive}
              selectedList={selectedList}
              activeTab={activeTab}
              secondaryTabActive={secondaryTabActive}
            />
          ))}
          {isCardShow && <PremiumCard />}
        </div>
      ) : (
        <EmptyState className="overview-empty" />
      )}

      {shouldRenderStories &&
        (shouldShowCarousel ? (
          <>
            <JourneysCarousel
              successStories={stories}
              carousalResponsive={[
                { breakpoint: 1427, settings: { slidesToShow: 1.5 } },
                { breakpoint: 1277, settings: { slidesToShow: 1.2 } },
                { breakpoint: 1064, settings: { slidesToShow: 1 } },
                { breakpoint: 920, settings: { slidesToShow: 0.7 } },
                { breakpoint: 820, settings: { slidesToShow: 1.2 } },
                { breakpoint: 606, settings: { slidesToShow: 1 } },
              ]}
            />
            <OverViewCarousal
              isLoading={isBlogLoading}
              carousalClass="blog-carousal"
              cardTitle={isMobile ? "Match diaries" : "Blogs"}
              cardDesc="Explore our blogs to enhance your matchmaking experience."
              href="blog"
              autoplaySpeed={4000}
              autoplay={{ dotDuration: false }}
              slidesToShow={3}
              carousalData={blogData?.blog_data}
              renderItem={(item, i) => (
                <BlogCard key={i} blog={item} className="blog-card" />
              )}
              carousalResponsive={[
                { breakpoint: 1280, settings: { slidesToShow: 2.5 } },
                { breakpoint: 986, settings: { slidesToShow: 2 } },
                { breakpoint: 828, settings: { slidesToShow: 1.5 } },
                { breakpoint: 767, settings: { slidesToShow: 2.5 } },
                { breakpoint: 650, settings: { slidesToShow: 2 } },
                { breakpoint: 550, settings: { slidesToShow: 1.5 } },
              ]}
            />
          </>
        ) : (
          <SubscriptionCard
            title="Unlock premium matches – Find your perfect partner faster!"
            data={[
              "Profile boost & premium card",
              "Advanced search & filters",
              "Matchmaker insights",
              "Unlimited message",
            ]}
            btnText="See membership plans"
          />
        ))}

      {secondHalf.length > 0 && (
        <div className="explore-card-list relative">
          {isLoading
            ? Array.from({ length: 8 }).map((_, index) => (
                <Skeleton label={false} height={250} key={index} />
              ))
            : secondHalf.map((item) => (
                <ProfileCard
                  profile={item}
                  snippetProfileId={item.id}
                  key={item.id}
                  profileImage={item?.profileImage}
                  verificationType={item?.verificationType}
                  imageCount={item?.imageCount}
                  userName={item?.profileName}
                  lastSeen={item?.lastSeen}
                  userAge={item?.profileAge}
                  profileId={item?.profileId}
                  userHeight={item?.profileHeight}
                  religion={item?.religion}
                  profession={item?.profileOcc}
                  maritalStatus={item?.maritalStatus}
                  livesIn={item?.livesIn}
                  primaryLanguage={item?.primaryLanguage}
                  createdBy={item?.createdBy}
                  menuDrop={false}
                  isPremium={item?.isPremium}
                  isInterested={item?.isLike}
                  isNotInterested={isNotInterested}
                  isFavorite={item.isFav}
                  isImageRequested={item.image_request}
                  isPrivate={item.isShow && item.isPrivate}
                  aec_id={item?.aec_id}
                  cardClassName={!isPremium ? cardClassName : ""}
                  shareUrl={item?.shareUrl}
                  tabActive={tabActive}
                  selectedList={selectedList}
                  activeTab={activeTab}
                  secondaryTabActive={secondaryTabActive}
                />
              ))}
          {isCardShow && <PremiumCard showCard={false} />}
        </div>
      )}
    </>
  );
}

export default ListCards;
